
<!-- 登录页，注册页 -->

<!-- 登录页 -->
<template>
    <!-- 最外层的大盒子 -->
    <div>
      <div class="box">
        <!-- 滑动盒子 -->
        <div class="pre-box">
          <h1>WELCOME</h1>
          <p>JOIN US!</p>
          <div class="img-box">
            <img
              :src="require('../../assets/imags/loginPage/' + imageSrc)"
              alt=""
            />
          </div>
        </div>
  
  
        <!-- 注册盒子 -->
        <div class="register-form">
          <!-- 标题盒子 -->
          <div class="title-box">
            <h1>注册</h1>
          </div>
          <!-- 输入框盒子 -->
          <div>
            <input class="registerInput" type="text" placeholder="用户名" v-model="registerUserData.userName" /><br>
            <input class="registerInput" type="password" placeholder="密码" v-model="registerUserData.password" />
            <input class="registerInput" type="password" placeholder="确认密码" v-model="registerUserData.confirmPassword" />
            <input class="registerInput" id="emailInput" type="email" placeholder="邮箱" v-model="registerUserData.email" />
            <!-- 对发送验证码样式单独处理 -->
            <button @click="sendCode" :disabled="isSending">{{ sendButtonText }}</button>
  
            <input class="registerInput" type="number" placeholder="验证码" v-model="registerUserData.code"/>
          </div>
          <!-- 按钮盒子 -->
          <div class="btn-box">
            <button @click="registerMethod()">注册</button>
            <!-- 绑定点击事件 -->
            <p @click="mySwitch()">已有账号?去登录</p>
          </div>
        </div>
  
  
  
        <!-- 登录盒子 -->
        <div class="login-form">
          <!-- 标题盒子 -->
          <div class="title-box">
            <h1>登录</h1>
          </div>
          <!-- 输入框盒子 -->
          <div class="input-box">
            <input type="text" placeholder="用户名" v-model="loginUserData.userName"/>
            <input type="password" placeholder="密码" v-model="loginUserData.password"/>
          </div>
          <!-- 按钮盒子 -->
          <div class="btn-box">
            <button @click="loginMethod()">登录</button>
            <!-- 绑定点击事件 -->
            <p @click="mySwitch()">没有账号?去注册</p>
          </div>
        </div>
      </div>


      <div style="margin-top: 50%;">
         <!-- 底部导航 -->
      <el-footer>
        <div style="text-align: center;">
          2024 My Website. All rights reserved.<br />
          Contact: kelizhadan@gmail.com
          <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: none;">冀ICP备2024094674号-1</a>
        </div>
      </el-footer>
      </div>
    </div>
    
  </template>
  
  
  
  <script>
  // 引入jquery文件
  import $ from "jquery";
//   import Header from "../homePage/Header.vue";
  import axios from 'axios';
//   导入封装好的请求方法
import {sendCode,register,login} from '@/api/loginPage.js';
  
  
  export default {
    // 内部定义方法
    data() {
      return {
        flag: true,
        showBuble: false,
        imageSrc: "waoku.jpg",
  
        // 发送验证码按钮用到的数据
        isSending: false,
        timeLeft: 0,
        intervalId: null,
        
        
        // 注册提交的用户信息对象
        registerUserData:{
          userName:'',
          password:'',
          confirmPassword:'',
          email:'',
          code:''
        },
  
        // 登录提交数据
        loginUserData:{
          userName:'',
          password:''
        }
  
      };
    },
    computed: {
      sendButtonText() {
        if (this.isSending) {
          return `重新发送(${this.timeLeft}s)`;
        }
        return '发送验证码';
      },
    },
    components: {

    },
    methods: {
  
      // 用户登录的方法
      async loginMethod(){
        console.log("获取用户登录信息："+JSON.stringify(this.loginUserData));
        const data= await login(this.loginUserData);

        console.log("调用登录的方法，获取响应的数据为："+JSON.stringify(data));
  
        // 获取响应过来的数据中的status进行判断
        if(data.status === '200'){
          // 登录成功
        //   进行提示
        this.$message({
          message: data.message,
          type: 'success'
        });
          // 对data中的用户性别进行转换，1：男，0：女
          const gender= data.data.gender;
          if(!(gender ==='' || gender === null)){
            data.data.gender= gender == 1 ? '男' : '女';
          }
          // 对页面进行跳转，跳转到首页，并且将token存储到本地
          //存入localStorage
                          localStorage.setItem('accessUserData',JSON.stringify(data));
              //注意是router非route
                          this.$router.replace({path:'/'})
  
        }else if(data.status === '500'){
          alert(data.message);
        }
        
  
        // 不管登录成功还是失败，清除输入框中的内容
        this.clearLoginInput();
  
      },
  
  
      /**
       * 清除登录输入框中的内容
       */
      clearLoginInput(){
        this.loginUserData.password='';
        this.loginUserData.userName='';
      },
  
  
  
  
      // 发送验证码
      async sendCode() {
        if (this.isSending) {
          return; // 如果正在倒计时，则不执行发送操作
        }
  
        this.startCountdown(); // 假设验证码发送成功，开始倒计时
  
        // 发送验证码的请求
        const data= await sendCode(this.registerUserData.email);

        console.log("发送验证码："+JSON.stringify(data))
        if("500" === data.status){
          // 发送失败，调用方法，清除秒数
          this.clearAwaitSecond();
        }
  
      },
  
      // 如果发送失败，调用方法，清除秒数
      clearAwaitSecond(){
        clearInterval(this.intervalId);
            this.isSending = false;
      },
  
      startCountdown() {
        this.isSending = true;
        this.timeLeft = 60; // 倒计时60秒
        this.intervalId = setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft--;
          } else {
            clearInterval(this.intervalId);
            this.isSending = false;
          }
        }, 1000);
      },
      beforeDestroy() {
      // 清除倒计时
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
  
  
      // 注册提交的方法
      async registerMethod(){
        console.log("注册提交的数为："+JSON.stringify(this.registerUserData));
        // 使用axios将数传递到后台
        const data= await register(this.registerUserData);

        console.log("获取的注册响应数为："+JSON.stringify(data));
        // 对响应回来的数据中的code码进行判断
        if("200"===data.status){
          // 成功,进行提示
          this.$message({
          message: data.message,
          type: 'success'
          });
          // 清除输入框中的内容
          this.clearRegisterInput();
          // 清除发送验证码倒计时
          this.clearAwaitSecond();
        }
      },
  
      // 清除注册输入框中的内容
      clearRegisterInput(){
          this.registerUserData.userName='';
          this.registerUserData.password='';
          this.registerUserData.confirmPassword='';
          this.registerUserData.email='';
          this.registerUserData.code='';
      },
  
      mySwitch() {
        if (this.flag) {
          // 获取到滑动盒子的dom元素并修改它移动的位置
          $(".pre-box").css("transform", "translateX(100%)");
          // 获取到滑动盒子的dom元素并修改它的背景颜色
          $(".pre-box").css("background-color", "#c9e0ed");
          //修改图片的路径
          this.imageSrc = "wuwu.jpeg";
        } else {
          $(".pre-box").css("transform", "translateX(0%)");
          $(".pre-box").css("background-color", "#edd4dc");
          this.imageSrc = "waoku.jpg";
        }
        this.flag = !this.flag;
      },
    },
  };
  </script>
  
  
  <!-- 加上scoped这里定义的样式为当前组件的私有样式 -->
  <style scoped>
  /* 邮箱输入框样式 */
  #emailInput{
    width: 210px;
  }
  
  /* 注册输入框样式 */
  .registerInput{
    margin-left: 85px; /* 设置左边距为50px */
  
  }
  
  </style>
  
  <style scoped src="@/assets/css/loginPage/login.css">

  </style>